import { useAuthState } from 'contexts';
import useSessionId from './useSessionId';
import { getAccessToken } from '../services/authTokens';

const useHeaders = () => {
  const { person } = useAuthState();
  const sessionId = useSessionId();
  const token = getAccessToken();

  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    'Person-Id': person?.id || 0,
    'Session-Id': sessionId || 0,
  };
};

export default useHeaders;
